module.exports = __webpack_public_path__ + "media/images/background/google-review-dd43c94a8b1e501027ae89b10c861439.png";